// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/fonts/IRANSansX-DemiBold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    padding: 0;
    margin: 0;

}

@font-face {
    font-family: IranSans;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

body ,html {
    overflow-x: hidden;
    direction: rtl;
  background-color: #F5F9FF !important;
    font-family: IranSans !important;
}

@media (max-width:990px) {
   html ,body {
        overflow-y: scroll !important;
        overflow-x: hidden !important;
    }
}

/* استایل اصلی برای لایه‌بندی */
.app-layout {
  display: flex;
  min-height: 100vh;
  position: relative;
}

/* محتوای اصلی - قابل اسکرول */
.main-content {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin-right: 280px; 
}

.content-wrapper {
  flex: 1 1;
  overflow-x: hidden;
 
}

.sidebar-right {
  position: fixed;
  right: 0;
  top: 0;
  width: 280px;
  height: 100vh;
  background: #fff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 1000;
}

.content-wrapper::-webkit-scrollbar {
  width: 8px;
}

.content-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.content-wrapper::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 10px;
}

.content-wrapper::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.sidebar-right::-webkit-scrollbar {
  width: 5px;
}

.sidebar-right::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.sidebar-right::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}

/* ریسپانسیو برای موبایل */
@media (max-width: 768px) {
  .main-content {
    margin-right: 0px;
  }
  
  .sidebar-right {
    transform: translateX(100%);
    transition: transform 0.3s ease;
    width: 260px;
  }
  
  .sidebar-right.open {
    transform: translateX(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,SAAS;;AAEb;;AAEA;IACI,qBAAqB;IACrB,4CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,cAAc;EAChB,oCAAoC;IAClC,gCAAgC;AACpC;;AAEA;GACG;QACK,6BAA6B;QAC7B,6BAA6B;IACjC;AACJ;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,8BAA8B;AAC9B;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,0BAA0B;AAC1B;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,2BAA2B;IAC3B,+BAA+B;IAC/B,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["* {\n    padding: 0;\n    margin: 0;\n\n}\n\n@font-face {\n    font-family: IranSans;\n    src: url(\"/src/fonts/IRANSansX-DemiBold.woff\");\n}\n\nbody ,html {\n    overflow-x: hidden;\n    direction: rtl;\n  background-color: #F5F9FF !important;\n    font-family: IranSans !important;\n}\n\n@media (max-width:990px) {\n   html ,body {\n        overflow-y: scroll !important;\n        overflow-x: hidden !important;\n    }\n}\n\n/* استایل اصلی برای لایه‌بندی */\n.app-layout {\n  display: flex;\n  min-height: 100vh;\n  position: relative;\n}\n\n/* محتوای اصلی - قابل اسکرول */\n.main-content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  margin-right: 280px; \n}\n\n.content-wrapper {\n  flex: 1;\n  overflow-x: hidden;\n \n}\n\n.sidebar-right {\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: 280px;\n  height: 100vh;\n  background: #fff;\n  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  z-index: 1000;\n}\n\n.content-wrapper::-webkit-scrollbar {\n  width: 8px;\n}\n\n.content-wrapper::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n.content-wrapper::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 10px;\n}\n\n.content-wrapper::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.sidebar-right::-webkit-scrollbar {\n  width: 5px;\n}\n\n.sidebar-right::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.sidebar-right::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 5px;\n}\n\n/* ریسپانسیو برای موبایل */\n@media (max-width: 768px) {\n  .main-content {\n    margin-right: 0px;\n  }\n  \n  .sidebar-right {\n    transform: translateX(100%);\n    transition: transform 0.3s ease;\n    width: 260px;\n  }\n  \n  .sidebar-right.open {\n    transform: translateX(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
